import { useFormik } from 'formik';
import { pathOr } from 'ramda';
import { forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import Radio from 'components/lib/Radio/Radio';

const RadioGroup = Radio.Group;

const StyledRadio = styled(Radio)`
  margin-bottom: 5px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  font-size: 14px;
  flex-direction: column;
`;

const AddressLine = styled.div`
  text-indent: 24px;
`;

type FacilitySelectorProps = {
  facility: any;
  facilities: any[];
  setFunction: (facility: any) => void;
};

const FacilitySelector = forwardRef<HTMLFormElement, FacilitySelectorProps>(
  ({ facility, facilities, setFunction }, ref) => {
    const { submitForm, handleChange, values, handleSubmit } = useFormik({
      initialValues: {
        facility: facility
          ? facilities.find((f) => f.id === facility.id)
          : null,
      },
      onSubmit: setFunction,
    });

    useImperativeHandle(ref, () => ({ submit: submitForm }));

    return (
      <form autoComplete="none" onSubmit={handleSubmit}>
        <StyledRadioGroup
          name="facility"
          value={values.facility}
          onChange={handleChange}
        >
          <StyledRadio value={null}>None</StyledRadio>
          {facilities.map((facility) => {
            const hasName = facility.name && facility.name.trim().length;
            const hasAttention =
              facility.attention && facility.attention.trim().length;
            return (
              <Radio key={`address-${facility.id}`} value={facility}>
                {hasName > 0 && (
                  <>
                    <b>{facility.name}</b>
                    <br />
                  </>
                )}
                {hasAttention > 0 &&
                  (hasName ? (
                    <AddressLine>
                      ATTN:&nbsp;<b>{facility.attention}</b>
                    </AddressLine>
                  ) : (
                    <>
                      ATTN:&nbsp;<b>{facility.attention}</b>
                    </>
                  ))}
                <AddressLine>{facility.address.address1}</AddressLine>
                {facility.address.address2 && (
                  <AddressLine>{facility.address.address2}</AddressLine>
                )}
                <AddressLine>{`${facility.address.city}, ${
                  facility.address.state ? facility.address.state.abbr : ''
                } ${pathOr(
                  '',
                  ['address', 'postalCode'],
                  facility,
                )}`}</AddressLine>
              </Radio>
            );
          })}
        </StyledRadioGroup>
      </form>
    );
  },
);
FacilitySelector.displayName = 'FacilitySelector';

export default FacilitySelector;
